/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

import {localConfig} from '../localconfig/localconfig';
import {Injectable} from '@angular/core';
import {Hash} from '../types';

//een uiteindelijk loggerobject
export interface Sihwlogger {
  debug: Function;
  log: Function;
  info: Function;
  warn: Function;
  error: Function;
  loglevel: string;
  loglevelNr: number;
  effectiveLoglevel: string;
  effectiveLoglevelNr: number;
}

//voor het gemak gewoon een serverclass met de functie logger om een Sihwlogger te krijgen

@Injectable()
export class Sihwlog {
  private levels: Hash<number> = {
    'debug': 1,
    'log': 2,
    'info': 3,
    'warn': 4,
    'error': 5
  };


  constructor(private conf: localConfig) {
    //config: sihwlog.logging: boolean (standaard false)
    //en sihwlog.minLevel: (standaard 'debug')

  }

  /**
   * Geef een logger object terug op het gegeven level
   * @param loglevel
   * @param prefix eventuele prefix
   */
  logger(loglevel?: string, prefix?: string): Sihwlogger {
    let noop = function() {
    };

    //effectiveLoglevel uitrekenen
    loglevel ??= <string> this.conf.$('SIHW.sihwlog.defaultLevel', 'warn');
    if (!(loglevel in this.levels)) {
      throw(`sihwlog: onbekend loglevel ${loglevel}`);
    }
    let levelnr = this.levels[loglevel];
    let enabled = this.conf.$('SIHW.sihwlog.logging', true);
    let minLevelnr = this.levels[this.conf.$('SIHW.sihwlog.minLevel', 'warn')] || 4;
    let effectiveNr = levelnr >= minLevelnr ? levelnr : minLevelnr;
    let logger: Sihwlogger = {
      debug: noop,
      log: noop,
      info: noop,
      warn: noop,
      error: noop,
      loglevel: loglevel,
      loglevelNr: levelnr,
      effectiveLoglevelNr: effectiveNr,
      effectiveLoglevel: <string> Object.keys(this.levels).find(level => this.levels[level] === effectiveNr)
    };

    for (let level of Object.keys(this.levels)) {
      if (enabled && this.levels[level] >= minLevelnr && this.levels[level] >= levelnr) {
        let argarray: string[] = [];
        let consolelevel = level;
        if (level === 'debug') {
          argarray.push('*');
          consolelevel = 'log';
        }
        if (prefix) {
          argarray.push(`[${prefix}]`);
        }
        (<Hash<any>> logger)[level] = (<Hash<any>> console)[consolelevel].bind(console, ...argarray);
      }
    }
    return logger;
  }
}
